import { useNavigate } from "react-router-dom";
import logo from "../Images/Logos/logo.png";

const Logo = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/");
  };
  return (
    <div
      onClick={handleNavigation}
      className="flex gap-1 items-center cursor-pointer"
    >
      <img src={logo} alt="Business Logo" className="sm:w-16 w-12" />
      <div className="uppercase">
        <h2 className="logo-font text-xl font-semibold tracking-wider">
          Janica
        </h2>
        <p className="logo-font1 sm:leading-none leading-4">
          Electronics <span className="text-xs">Pvt Ltd</span>
        </p>
      </div>
    </div>
  );
};

export default Logo;
